import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import AboutPage from "../views/AboutPage.vue";
import MshelMentorship from "@/views/MshelMentorship.vue";
import MasterclassClub from "@/views/MasterclassClub.vue";
import MshelClub from "@/views/MshelClub.vue";
import MmcRegistrationForm from "@/views/MmcRegistrationForm.vue";
import MremRegistrationForm from "@/views/MremRegistrationForm.vue";
import ContactPage from "@/views/ContactPage.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "home",
      component: HomePage,
    },
    {
      path: "/about",
      name: "about",
      component: AboutPage,
    },
    {
      path: "/mshel-club",
      name: "mshel-club",
      component: MshelClub,
    },
    {
      path: "/mshel-mentorship-club",
      name: "mshel-mentorship",
      component: MshelMentorship,
    },
    {
      path: "/mshel-mentorship-club/registration-form/:id",
      name: "mmc-registration-form",
      component: MmcRegistrationForm,
    },
    {
      path: "/mshel-realestate-masterclass-club",
      name: "masterclass-club",
      component: MasterclassClub,
    },
    {
      path: "/mshel-realestate-masterclass-club/registration-form/:id",
      name: "mrem-registration-form",
      component: MremRegistrationForm,
    },
    {
      path: "/contact",
      name: "contact-us",
      component: ContactPage,
    },
  ],
});

export default router;
